<template>
  <div class="cont">
    <div class="title">
      <div class="title_name"></div>
    </div>

    <div class="clear" style="margin-bottom:37px">
      <div class="img_cont img_cont_one clear"  @click="gotoDetail('EC型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>


        <div class="img_cont img_cont_four clear"  style="margin-left:37px"  @click="gotoDetail('Premium型')">
            <div class="img_one img"></div>
            <div class="img_two img"></div>
            <div class="img_desc"></div>
        </div>


        <div class="img_cont img_cont_three clear"    @click="gotoDetail('M型')">
            <div class="img_one img"></div>
            <div class="img_two img"></div>
            <div class="img_desc"></div>
        </div>


        <div class="img_cont img_cont_two clear" style="margin-left:37px" @click="gotoDetail('ES型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>


        <div class="img_cont img_cont_s clear"   @click="gotoDetail('S型')"  >
            <div class="img_one img"></div>
            <div class="img_two img"></div>
            <div class="img_desc"></div>
        </div>

        <div class="img_cont img_cont_eighteen clear"  style="margin-left:37px"  @click="gotoDetail('Z型')">
            <div class="img_one img"></div>
            <div class="img_two img" ></div>
            <div class="img_desc"></div>
        </div>

        <div class="img_cont img_cont_seventeen clear"  @click="gotoDetail('X型')" >
        <div class="img_one img"></div>
        <div class="img_two img" ></div>
        <div class="img_desc"></div>
      </div>


      <div class="img_cont img_cont_eight clear"   style="margin-left:37px" @click="gotoDetail('RE型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

         <div class="img_cont img_cont_six clear"   @click="gotoDetail('RA型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <div class="img_cont img_cont_five clear" style="margin-left:37px" @click="gotoDetail('R01型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>



      <div class="img_cont img_cont_seven clear" @click="gotoDetail('RD型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>




          <div class="img_cont img_cont_twelve clear" style="margin-left:37px" @click="gotoDetail('RN型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      <div class="img_cont img_cont_ten clear"  @click="gotoDetail('RGS型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>


      <div class="img_cont img_cont_nine clear"  style="margin-left:37px" @click="gotoDetail('RGM型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <div class="img_cont img_cont_eleven clear"   @click="gotoDetail('RGX型')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>



      <div class="img_cont img_cont_thirteen clear"  style="margin-left:37px" @click="gotoDetail('Specom_GT')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <!-- <div class="img_cont img_cont_fourteen clear" @click="gotoDetail('Specom_K')" >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div> -->

      <div class="img_cont img_cont_fifteen clear"  @click="gotoDetail('Specom_α')"  >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <div class="img_cont img_cont_sixteen clear" style="margin-left:37px"  @click="gotoDetail('Specom_β')" >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>






    </div>


  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain"
    };
  },
  methods: {
    gotoDetail( id ){
      // console.log( id )
      this.$router.push('/variousproducts/brakePads/' + id )

    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after {
  display: block;
  clear: both;
  content: '';
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/brakePads/img31.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 41px 42px 39px 42px;
  box-sizing: border-box;
}

.title_name {
  width: 86px;
  height: 28px;
  background: url('~@/assets/image/variousproducts/brakePads/img32.png');
  background-repeat: no-repeat;
  background-size: contain;
}


.img_cont {
  width: 410px;
  height: 103px;
  float: left;
  cursor pointer
}
  .img{
    background-repeat: no-repeat;
    background-size: cover;
    float: left;
  }


/* 对应 gotoDetail('EC型') */
.img_cont_one
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img1.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 92.7px; /* 图片 151x100 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/EC.png');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/EC.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;

  }
/* 对应 gotoDetail('ES型') */
.img_cont_two
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img5.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 96.8px; /* 图片 146x101 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/ES.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 47px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img7.png');
    background-repeat: no-repeat;
    margin-bottom: 9px
  }
  .img_four{
    width: 171px;
    height: 71px;
    background: url('~@/assets/image/variousproducts/brakePads/img8.png');
  }
  /* 对应 ES型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/ES.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('M型') */
.img_cont_three
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img9.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 99.3px; /* 图片 141x100 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/M.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 44px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img11.png');
    background-repeat: no-repeat;
    margin-bottom:9px
  }
  .img_four{
    width: 186px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/brakePads/img12.png');
  }
  /* 对应 M型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/M.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('Premium型') */
.img_cont_four
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img13.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 92.7px; /* 图片 151x100 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/P.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 120px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img15.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four{
    width: 151px;
    height: 53px;
    background: url('~@/assets/image/variousproducts/brakePads/img16.png');
  }
  /* 对应 Premium型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/P.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('R01型') */
.img_cont_five
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img17.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 75.4px; /* 图片 182x98 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/R01.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 63px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img19.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four{
    width: 166px;
    height: 16px;
    background: url('~@/assets/image/variousproducts/brakePads/img20.png');
  }
  /* 对应 R01型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/R01.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('RA型') */
.img_cont_six
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img21.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 79.3px; /* 图片 180x102 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/RA.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 52px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img23.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 180px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakePads/img24.png');
  }
  /* 对应 RA型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/RA.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('RD型') */
.img_cont_seven
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img25.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 110.2px; /* 图片 141x111 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/RD.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 54px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img27.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 181px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakePads/img28.png');
  }
  /* 对应 RD型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/RD.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('RE型') */
.img_cont_eight
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img41.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 79.3px; /* 图片 180x102 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/RE.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 49px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img43.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 124px;
    height: 16px;
    background: url('~@/assets/image/variousproducts/brakePads/img44.png');
  }
  /* 对应 RE型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/RE.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('RGM型') */
.img_cont_nine
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img45.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 113.6px; /* 图片 143x116 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/RGM.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 75px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img47.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 136px;
    height: 15px;
    background: url('~@/assets/image/variousproducts/brakePads/img48.png');
  }
  /* 对应 RGM型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/RGM.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

/* 对应 gotoDetail('RGS型') */
.img_cont_ten
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img49.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 91.8px; /* 图片 151x99 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/RGS.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 67px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img51.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 166px;
    height: 16px;
    background: url('~@/assets/image/variousproducts/brakePads/img52.png');
  }
  /* 对应 RGS型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/RGS.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('RGX型') */
.img_cont_eleven
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img53.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 91.8px; /* 图片 151x99 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/RGX.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 68px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img55.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 180px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakePads/img56.png');
  }
  /* 对应 RGX型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/RGX.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('RN型') */
.img_cont_twelve
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img57.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 110.8px; /* 图片 139x110 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/RN.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 55px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img59.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 215px;
    height: 16px;
    background: url('~@/assets/image/variousproducts/brakePads/img60.png');
  }
  /* 对应 RN型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/RN.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('Specom_GT') */
.img_cont_thirteen
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img61.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 92px; /* 图片 350x230 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/Specom-GT.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 128px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/brakePads/img63.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 198px;
    height: 16px;
    background: url('~@/assets/image/variousproducts/brakePads/img64.png');
  }
  /* 对应 Specom_GT 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/GT.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('Specom_K') */
.img_cont_fourteen
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img65.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 103px; /* 图片 140x103 与容器一致 */
    background: url('~@/assets/image/variousproducts/brakePads/img66.png');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 112px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/brakePads/img67.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 164px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakePads/img68.png');
  }
/* 对应 gotoDetail('Specom_α') */
.img_cont_fifteen
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img69.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 92px; /* 图片 350x230 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/Specom-α.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 113px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/brakePads/img71.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 237px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakePads/img72.png');
  }
  /* 对应 Specom_α 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/α.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('Specom_β') */
.img_cont_sixteen
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img73.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 92px; /* 图片 350x230 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/Specom-β.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 111px;
    height: 24px;
    background: url('~@/assets/image/variousproducts/brakePads/img75.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 245px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakePads/img76.png');
  }
  /* 对应 Specom_β 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/β.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('X型') */
.img_cont_seventeen
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img77.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 92px; /* 图片 140x90 与容器同比例 */
    margin-right:6px;
    background: url('~@/assets/image/variousproducts/brakePads/X.jpg');
    background-size: contain;
    background-position: center;
  }
  .img_three{
    width: 37px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img79.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 188px;
    height: 15px;
    background: url('~@/assets/image/variousproducts/brakePads/img80.png');
  }
  /* 对应 X型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/X.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('Z型') */
.img_cont_eighteen
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img81.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 92.7px; /* 图片 151x100 等比例高度 */
    background: url('~@/assets/image/variousproducts/brakePads/Z.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 37px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/img83.png');
    background-repeat: no-repeat;
    margin-bottom:10px
  }
  .img_four {
    width: 150px;
    height: 33px;
    background: url('~@/assets/image/variousproducts/brakePads/img84.png');
  }
  /* 对应 Z型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/Z.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
/* 对应 gotoDetail('S型') */
.img_cont_s
  margin-top: 37px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakePads/img81.png');
    margin-right:5px;
  }
  .img_two{
    width: 140px;
    height: 100.1px; /* 图片 260x190 等比例高度 */
    background-repeat: no-repeat;
    background: url('~@/assets/image/variousproducts/brakePads/S.jpg');
    background-size: contain;
    background-position: center;
    margin-right:6px;
  }
  .img_three{
    width: 34px;
    height: 21px;
    background: url('~@/assets/image/variousproducts/brakePads/90.png');

    margin-bottom:10px
  }
  .img_four {
    width: 175px;
    height: 14px;
    background: url('~@/assets/image/variousproducts/brakePads/89.png');
  }
  /* 对应 S型 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakePads/desc/S.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }


</style>
